import React, { useMemo, useEffect, type ReactNode } from 'react'
import { ThemeContext } from './themeContext'

export interface ThemeContextType {
  theme: 'dark'
}

interface ThemeProviderProps {
  children: ReactNode
}

const DARK_VALUE: ThemeContextType = { theme: 'dark' }

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  useEffect(() => {
    if (globalThis.window === undefined) return
    const root = document.documentElement
    root.classList.remove('light')
    root.classList.add('dark')
    root.dataset.theme = 'dark'
  }, [])

  const value = useMemo(() => DARK_VALUE, [])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export default ThemeProvider
